import { combineReducers } from '@reduxjs/toolkit';
import ViewReducers from './view';
import UsersReducers from './users';
import AccountsReducers from './accounts';
import TeamsReducer from './teams';
import { invoicesReducer } from './invoices';

const adminDashboardReducers = combineReducers({
  view: ViewReducers,
  users: UsersReducers,
  accounts: AccountsReducers,
  teams: TeamsReducer,
  invoices: invoicesReducer
});

export default adminDashboardReducers;

export type AdminDashboardReducers = ReturnType<typeof adminDashboardReducers>
